import React, {Fragment} from 'react';
import clsx from 'clsx';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {Hidden, ListItem, Button, Drawer, Paper} from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
    setActiveLink,
    setSidebarHover,
    setSidebarToggleMobile
} from '../../vendors/actions/layout';
import {
    UserBox as SidebarUserbox,
    Header as SidebarHeader
} from './elements'
import navItems from "./navItems";

interface OwnProps {

}

interface ConnectStateProps {
    User: {
        first_name: string;
        last_name: string;
        isAuthenticated?: boolean;
    }
}

interface ConnectDispatchProps {
    setSidebarHover?: (data: any) => void;
    setSidebarToggleMobile?: (data: any) => void;
    setActiveLink?: (data: number) => void;
}

const Sidebar = (props: any) => {
    const {
        setSidebarToggleMobile,
        setActiveLink,
        history
    } = props;

    const {
        sidebarToggleMobile,
        sidebarFixed,
        sidebarHover,
        sidebarToggle,
        sidebarUserbox = true,
        sidebarShadow,
        activeLink,
    } = props.Layout;

    const toggleHoverOn = () => props.setSidebarHover(true);
    const toggleHoverOff = () => props.setSidebarHover(false);

    const navigate = (e: any, url: string) => {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
        if (url === 'logout') {
            localStorage.removeItem('token');
            return window.location.href = '/';
        } else if (url === '/faq') {
           return window.open(
                'https://andlawyers.com',
                '_blank'
            );
        }
        return history.push(url)
    };

    const closeDrawer = () => setSidebarToggleMobile(!sidebarToggleMobile);
    const sidebarMenuContent = (
        <div
            className={clsx({
                'app-sidebar-nav-close': sidebarToggle && !sidebarHover
            })}>
            {navItems.map((list: any, key: number) => {
                   return (
                        <ListItem key={key}
                                  className={clsx('app-sidebar-item')}
                                  disableGutters>
                            <Button
                                onClick={(e) => {
                                    list.to !== '/faq' && setActiveLink(list.to);
                                    navigate(e, list.to)
                                }}
                                color="primary"
                                disableRipple
                                variant="text"
                                className={clsx('app-sidebar-button-wrapper', `depth-0`, {'active': list.to === activeLink})}
                                href={list.to}
                            >
                                {list.icon && <list.icon className={`app-sidebar-icon ${list.className}`}/>}
                                {list.label}
                            </Button>
                        </ListItem>
                    )
                }
            )}
        </div>
    );

    return (
        <Fragment>
            <Hidden lgUp>
                <Drawer
                    anchor="left"
                    open={sidebarToggleMobile}
                    onClose={closeDrawer}
                    variant="temporary"
                    elevation={4}
                    className="app-sidebar-wrapper-lg">
                    <SidebarHeader/>
                    <PerfectScrollbar>
                        {sidebarUserbox && <SidebarUserbox history={history}/>}
                        {sidebarMenuContent}
                    </PerfectScrollbar>
                </Drawer>
            </Hidden>

            <Hidden mdDown>
                <Paper
                    onMouseEnter={toggleHoverOn}
                    onMouseLeave={toggleHoverOff}
                    className={clsx('app-sidebar-wrapper', {
                        'app-sidebar-wrapper-close': sidebarToggle,
                        'app-sidebar-wrapper-open': sidebarHover,
                        'app-sidebar-wrapper-fixed': sidebarFixed
                    })}
                    square
                    //open={sidebarToggle}
                    elevation={sidebarShadow ? 11 : 3}>
                    <SidebarHeader/>
                    <div
                        className={clsx({
                            'app-sidebar-menu': sidebarFixed,
                            'app-sidebar-collapsed': sidebarToggle && !sidebarHover
                        })}>
                        <PerfectScrollbar options={{wheelPropagation: false}}>
                            {sidebarUserbox && <SidebarUserbox history={history}/>}
                            {sidebarMenuContent}
                        </PerfectScrollbar>
                    </div>
                </Paper>
            </Hidden>
        </Fragment>
    );
};


type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User, Layout} = state;
    return {User, Layout}
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        setSidebarHover: (data: any) => dispatch(setSidebarHover(data)),
        setActiveLink: (data: any) => dispatch(setActiveLink(data)),
        setSidebarToggleMobile: (data: any) => dispatch(setSidebarToggleMobile(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);


